export const ChatUtils = {
  formatSelectedTextAndMessage(
    selectedText: string,
    userMessage: string
  ): string {
    if (!selectedText) return userMessage;

    return `${selectedText} -> ${userMessage}`;
  }
};
